export default __webpack_public_path__ + "static/media/lodding_icon.cc57505c.gif";